export const prettyNum = (value: number | bigint | string) =>
    String(value).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
